export default {
	sec_01: {
		title: {
			one: 'For the mind of the',
			two: 'customer ',
			three: 'and the ',
			four: 'consumer',
		},
		desc: {
			one: 'We can to protect our business using machine learning and',
			two: "protect both our customers' assets and our consumers.",
		},
	},
	sec_14: {
		desc: {
			one: 'Does your business need a highly customizable commerce solution?',
		},
		btn: 'Learn about JP WORLD Pay for Business',
	},
	sec_03: {
		title: {
			one: 'Rich Experience',
		},
		desc: {
			one: 'Please use the trannsaction safely through JP WORLD Pay, which was created based on the',
			two: 'blockchain know-how that started from the beginning of the blockchain being known.',
		},
		one: {
			title: {
				one: 'Transaction safely',
			},
			desc: {
				one: "With the world's most secure blockchain,",
				two: 'we can reach customers around the world.',
			},
		},
		two: {
			title: {
				one: 'Fraud detection technology',
			},
			desc: {
				one: 'Our fraud detection tools get smarter with each transaction,',
				two: 'protecting you from existing and evolving threats.',
			},
		},
	},
};
